import constants from '../constants/appConstants';

const URL = constants.API.calculator;

/**
 * Converts the internal preferences format
 *   [{ name, isActive, value? }]
 * to the Lambda scenario format
 *   [{ name, value? }]
 * keeping only active preferences.
 */
function buildScenario(preferences) {
  return preferences
    .filter(p => p.isActive)
    .map(({ name, value }) => (value !== undefined && value !== 0 ? { name, value } : { name }));
}

/**
 * Posts the user's active preferences to the Lambda calculator and returns
 * the first result (which includes dailyAverage, matchedVehicles, etc.).
 *
 * Returns null when:
 *  - the URL is not configured
 *  - no active preferences were provided
 *  - the request fails for any reason
 *
 * @param {Array<{ name: string, isActive: boolean, value?: any }>} preferences
 * @param {AbortSignal} [signal] - optional AbortSignal to cancel the request
 * @returns {Promise<{ dailyAverage: number, matchedVehicles: number, totalVehicles: number, matchRate: string } | null>}
 */
export async function getCalculatorScenarios(preferences, signal) {
  if (!URL || !Array.isArray(preferences) || preferences.length === 0) return null;

  const scenario = buildScenario(preferences);
  if (scenario.length === 0) return null;

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ scenarios: [scenario] }),
      signal,
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data.results?.[0] ?? null;
  } catch (err) {
    if (err.name === 'AbortError') return null;
    console.error('[calculator] Lambda call failed:', err);
    return null;
  }
}

/**
 * @deprecated No longer needed — scenario matching is now handled by the Lambda.
 * Kept to avoid breaking imports that still reference this export.
 */
export function findMatchingScenario() {
  return null;
}
